export default __webpack_public_path__ + "static/media/contratacion.0dfd6127.png";